import { render, staticRenderFns } from "./PricingRuleLabelMappingFiles.vue?vue&type=template&id=73072e22&scoped=true&"
import script from "./PricingRuleLabelMappingFiles.vue?vue&type=script&lang=js&"
export * from "./PricingRuleLabelMappingFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73072e22",
  null
  
)

export default component.exports